export enum QuestionType {
  MOMENT = 1,
  PROMPT = 2
}

export enum OptionType {
  YES_NO = 1,
  GRADING = 2,
  MULTI_CHOICE = 3
}

export enum MomentOperation {
  NONE = 1,
  AND = 2,
  OR = 3,
  NOT = 4
}

export enum ResourceState {
  NEW = 1,
  IN_PROGRESS = 2,
  COMPLETED = 3,
  DELETED = 4,
  INACTIVE_IN_PROGRESS = 5,
  INACTIVE_COMPLETED = 6
}

export interface EvalFormDataResponse {
  evalform: EvalFormData;
}

export interface EvalFormData {
  id?: number;
  name: string;
  points: number;
  description: string;
  state_id: ResourceState;
  new_state_id?: ResourceState;
  is_shared_id: number;
  sections: EFSectionData[];
}

export interface EFSectionData {
  id?: number;
  name: string;
  description: string;
  order: number;
  points: number;
  form_id?: number;
  questions: EFQuestionData[];
}

export interface EFQuestionData {
  id?: number;
  order: number;
  points: number;
  description: string;
  type_id: number;
  type?: string;
  option_type_id: number;
  option_type?: string;
  prompt?: string;
  examples: string[];
  options?: EFQuestionOptionData[];
  moments?: EFQuestionMomentData[];
  section_id?: number;
}

export interface EFQuestionMomentData {
  id?: number;
  order: number;
  moment_id: number;
  operation_id: number;
}

export interface EFQuestionOptionData {
  id?: number;
  order: number;
  points: number;
  description: string;
  question_id?: number;
}

export interface EFErrorResponse {
  errors?: {
    [key: string]: string[];
  };
  info?: {
    [key: string]: string[];
  };
  evalform: EvalFormData;
}